<div>
  <img src="assets/imgs/colorLogo.png" class="logo" />
</div>